import React, { useContext, useEffect, useState } from "react";
import { Row, Container, Col } from "react-bootstrap";
import { ThemeContext } from "../../theming";
import { User } from "../../assets/icons/dashboard";
import Logo from "../../assets/images/logo.png";
import Logo2 from "../../assets/images/logo_footer.png";
import Pulgar from "../../assets/images/pulgar.png";
import CerrarSesion from "../../assets/images/cerrar-sesion.png";
import useWindowDimensions from "../../helpers/useWindowDimensions";
import { NotificationCliente, UserCliente } from "../../assets/icons/dashboard";
import { Link, Pipe, Text, TextGeneric } from "../typography";
import { mobileXSWidth, mobileLDWidth } from '../../helpers/responsiveVariables';

const headerHeight = 110;

export default function Header({ openModal, notificaciones, nombres }) {
  const app = useContext(ThemeContext);

  const { body12, body14, body25, body28 } = app.theme.font;

  const [nombre, setNombre] = useState(JSON.parse(localStorage.getItem("user"))?.n??"");
  const rut = JSON.parse(localStorage.getItem("user"))?.rd??"";
  const { width } = useWindowDimensions();

  const header = {
    backgroundColor: app.theme.secondary,
    // width: '100%',
    height: `${headerHeight}px`,
    borderStyle: "solid",
    borderWidth: "1px",
    borderBottomColor: "white",
    // display: 'flex',
    // alignItems: 'center',
    // paddingRight: '0px',
    // marginRight: '0px'
  };

  const border = {
    borderBottom: `2px solid ${app.theme.primary}`,
    paddingBottom: "3px",
  };
  const cerrarSesionClick = ()=>{
    localStorage.clear();
    window.location.href = window.WEB_PORTAL_CLIENTES;

  }

  /* useEffect(() => {
    let user = JSON.parse(localStorage.getItem('user'));
    let publicURL = PORTALSAPI.GET.PUBLIC_KEY
      .replace("{idcontacto}", user.idcontacto)
      .replace("{tipo}", user.tipo_acceso);
    api.get(publicURL).then((response) => {
      if (user) {
        if (nombres == "") {
          setUsuario(DecryptData(user.nombres, response.data));
        } else {
          setUsuario(nombres);
        }
        setCliente(DecryptData(user.cliente, response.data));
      }
    });
  }, [nombres]); */

  return (
    <Container fluid style={header} className="sticky-top">
      {width >= 801 ? (
        <Col className="mt-3">
          <Row className="align-items-center justify-content-md-center ms-4">
            <Col className="" lg={1}>
              <img width="80px" src={Logo} alt="" />
            </Col>

            <Col lg={4}>
              <Row className="align-items-center justify-content-md-end">
                <Col lg={1}>
                  <Pipe size={30} color="yellow" />
                </Col>
                {
                  width > mobileXSWidth ?
                    <Col>
                      <Text size={body25}>PORTAL PAGOS - FINTEC PARA CLIENTES</Text>
                    </Col>
                    :
                    <></>
                }
              </Row>
            </Col>

            <Col lg={1}>
              <div className="row justify-content-end">
                <Row>
                  <Text size={body14} style={{textAlign : "center"}} bold>
                    
                  </Text>
                </Row>
              </div>
            </Col>

            <Col lg={6}>
              <div className="d-flex justify-content-center">
                <div className="w-75">
                  <Row className="justify-content-end">
                    <TextGeneric className={width > mobileXSWidth ? 'text-end' : "text-center"}
                      size={1} color={"white"}>
                      <b >
                        {"Bienvenido, "+nombre}
                      </b>
                    </TextGeneric>
                  </Row>
                  <Row className="justify-content-end">
                    <TextGeneric className={width > mobileXSWidth ? 'text-end' : "text-center"}
                      size={width < 1080 ? 0.7 : 0.8} color={"white"}>
                        {"RUT: "+rut}
                    </TextGeneric>
                  </Row>
                </div>
                <div style={{marginRight : "12px", marginLeft : "32px"}}>
                  <img height={width > mobileLDWidth ? 45 : 35} width={width > mobileLDWidth ? 45 : 35} alt="" src={CerrarSesion} style={{cursor: "pointer"}}
                    onClick={cerrarSesionClick} />
                </div>
              </div>

							</Col> 

          </Row>
        </Col>
      ) : (
        <Col className="mt-4">
          <Row className="align-items-center justify-content-md-center ms-2">
            <Col className="" lg={1} xs={2}>
              <img width="40px" src={Logo2} alt="" />
            </Col>

            <Col lg={2} xs={7} style={{ textAlign: "end" }}>
              <div className="row justify-content-end">
                <Row>
                  <Text size={body14} style={{textAlign : "center"}} bold>
                  PORTAL PAGOS - FINTEC PARA CLIENTES
                  </Text>
                </Row>
              </div>
            </Col>

            <Col lg={1} xs={3}>
              <Row>
              <div className="d-flex justify-content-center">
                <div style={{marginRight : "12px"}}>
                  <img height={width > mobileLDWidth ? 45 : 35} width={width > mobileLDWidth ? 45 : 35} alt="" src={CerrarSesion} style={{cursor: "pointer"}}
                  onClick={cerrarSesionClick}/>
                </div>
              </div>
              </Row>
            </Col> 
          </Row>
        </Col>
      )}
    </Container>
  );
}
